module.exports = __webpack_public_path__ + "static/media/Asset 6.1@3x.ebf0504d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 6.1@3x.png
// module id = 2395
// module chunks = 0